import "core-js/modules/es.array.slice";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
export default {
  data: function data() {
    return {
      visible: false
    };
  },
  computed: {
    list: function list() {
      return this.starList.slice(0, 3);
    }
  },
  methods: {
    close: function close() {
      this.visible = false;
    },
    bindEvent: function bindEvent() {
      var _this = this;

      this.eventBus.$on('showActorListPop', function () {
        _this.visible = true;
      });
    }
  },
  mounted: function mounted() {
    this.bindEvent();
  }
};